/* global attachEvent, slideToggle */

// *************************
// Toggel key data
// *************************

attachEvent('.key-data__placeholder', 'click', (ev) => {
  const parentListBlock = ev.target.closest('.list-block');
  const keydataList = parentListBlock.querySelectorAll('.list-block__content-collapsible')[0];
  parentListBlock.classList.toggle('is-open-list');
  slideToggle(keydataList, 300);
});
